import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LibConfig, LibConfigService } from '../config/environment.config';
import { QuestionnaireDTO } from '../models/check-interface';

@Injectable({
  providedIn: 'root'
})
export class QuestionnairesService {

  private authHeaderOptions: any;
  private libConfig: LibConfig;
  public editQuestionnaire: QuestionnaireDTO;
  public fromDuplicate: boolean = false;

  public newQuestion = {};
  public editQuestion = {};

  constructor(
    private http: HttpClient,
    @Inject(LibConfigService) config: LibConfig
  ) {
    this.libConfig=config;
  }

  setHeader(isAuth: boolean) {
    const headers: any = {};
    if (isAuth) {
      headers.Authorization = 'Bearer ' + localStorage.getItem('access_token');
    }

    headers['Content-Type'] = 'application/json';
    headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
    headers['Pragma'] = 'no-cache';
    headers['Pragma-Directive'] = 'no-cache';
    headers['Cache-Directive'] = 'no-cache';
    headers['max-age'] = '0';
    headers['expires'] = '0';
    this.authHeaderOptions = { headers: new HttpHeaders(headers) };
  }

  putApi(url: string, postValue: any, isAuth: boolean) {
    this.setHeader(isAuth);
    return this.http.put(`${this.libConfig.api_url}${url}`, postValue, this.authHeaderOptions);
  }

  getApi(url: string, isAuth: boolean) {
    this.setHeader(isAuth);
    return this.http.get(`${this.libConfig.api_url}${url}`, this.authHeaderOptions);
  }

  postApi(url: string, postValue: any, isAuth: boolean) {
    this.setHeader(isAuth);
    return this.http.post(`${this.libConfig.api_url}${url}`, postValue, this.authHeaderOptions);
  }

  deleteApi(url: string, isAuth: boolean) {
    this.setHeader(isAuth);
    return this.http.delete(`${this.libConfig.api_url}${url}`, this.authHeaderOptions);
  }

  getByInstitution(institutionId: number) {
    const url = `Questionnaires/GetEditedListByInstitution/${institutionId}`;
    return this.getApi(url, true);
  }

  putNotesUserQuestionnaires(userQuestionnaireId: string, notes: string) {
    const url = 'UserQuestionnaires/'+userQuestionnaireId;
    return this.putApi(url, `"${notes}"`, true);
  }

  putUserQuestionnaires(data: any) {
    const url = `UserQuestions`;
    return this.putApi(url, data, true);
  }

  putCommentUserQuestion(userId: string, comment: string) {
    const url = 'UserQuestions/'+userId;
    return this.putApi(url, '"'+comment+'"', true);
  }

  getQuestionnairesByInstitutionId(institutionId: number) {
    const url = `Questionnaires/${institutionId}`;
    return this.getApi(url, true);
  }

  getQuestionnairesListForEditor(roleId: number, entityId: number) {
    const url = `GetQuestionnairesWithUsers/${roleId}/${entityId}`;
    return this.getApi(url, true);
  }

  putDefaultQuestionnaireForEntity(data: any) {
    const url = `Questionnaires/DefaultQuestionnaire`;
    return this.putApi(url, data, true);
  }

  duplicateQuestionnaire(data: any) {
    const url = `Questionnaires/Duplicate`;
    return this.postApi(url, data, true);
  }

  hasChecksInProgressForQuestionnaire(questionnaireId: any) {
    const url = `UserQuestionnaires/HasChecksInProgressForQuestionnaire/${questionnaireId}`;
    return this.getApi(url, true);
  }

  deleteQuestionnaire(questionnaireId: any, userId: any) {
    const url = `Questionnaires/${questionnaireId}/${userId}`;
    return this.deleteApi(url, true);
  }

  getQuestionnaireById(questionnaireId: any) {
    const url = `Questionnaires/GetById/${questionnaireId}`;
    return this.getApi(url, true);
  }

  updateQuestionnaire(questionnaireInput: any) {
    const url = `Questionnaires/${questionnaireInput.questionnaire.id}`;
    return this.putApi(url, questionnaireInput, true);
  }

  // updateQuestionnaire(questionnaire: any, userId: number) {
  //   const url = `Questionnaires/${questionnaire.id}/${userId}`;
  //   return this.putApi(url, questionnaire, true);
  // }

  createQuestionnaire(questionnaire: any, userId: number, roleID: number) {
    const url = `Questionnaires/new/${userId}/${roleID}`;
    return this.postApi(url, questionnaire, true);
  }
}
